import { API_ENDPOINT_URL } from '@moxie/constants';
import { IResponse } from '@shared-components/models';
import { axiosInstance as axios } from './axios';

const getChecklists = async (): Promise<IResponse> => {
  return axios.get(API_ENDPOINT_URL.CHECKLISTS);
};

export { getChecklists };
